module.exports = __webpack_public_path__ + "static/img/micro.8752452c.svg";